import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { FullscreenPortal } from 'core/utils/fullscreenContainer';

interface NoShiftsToPublishDialogProps {
	onClose: () => void;
}

const NoShiftsToPublishDialog: React.FC<NoShiftsToPublishDialogProps> = ({ onClose }) => {
	return (
		<FullscreenPortal>
			<Box
			sx={{
				position: 'fixed',
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				backgroundColor: 'rgba(0, 0, 0, 0.5)',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				zIndex: 9999,
			}}
			onClick={onClose}
		>
			<Paper
				onClick={(e) => e.stopPropagation()}
				sx={{
					width: '90%',
					maxWidth: '500px',
					padding: '32px',
					borderRadius: '8px',
				}}
			>
				<Typography
					variant="h5"
					sx={{
						marginBottom: '24px',
						fontFamily: 'Gotham, sans-serif',
						fontWeight: 500,
						color: 'rgb(68, 99, 136)',
					}}
				>
					Publish Schedule
				</Typography>

				<Typography
					sx={{
						marginBottom: '32px',
						fontSize: '16px',
						fontFamily: 'Gotham, sans-serif',
						color: '#333',
						lineHeight: 1.6,
					}}
				>
					There must be shifts in the week before it can be published. Add shifts to the schedule and try
					again.
				</Typography>

				<Box sx={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
					<button
						type="button"
						onClick={onClose}
						style={{
							backgroundColor: 'rgb(68, 99, 136)',
							color: 'white',
							border: 'none',
							borderRadius: '6px',
							padding: '0 24px',
							height: '32px',
							fontFamily: 'Gotham, sans-serif',
							fontSize: '14px',
							cursor: 'pointer',
							fontWeight: 500,
						}}
						onMouseEnter={(e) => {
							e.currentTarget.style.backgroundColor = 'rgb(57, 80, 111)';
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.backgroundColor = 'rgb(68, 99, 136)';
						}}
					>
						OK
					</button>
				</Box>
			</Paper>
		</Box>
		</FullscreenPortal>
	);
};

export default NoShiftsToPublishDialog;
